var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25978 7.26764C6.74645 6.87431 6.25978 6.46764 6.25978 5.83431C6.25978 5.10764 6.93311 4.60098 8.05978 4.60098C9.24645 4.60098 9.68645 5.16764 9.72645 6.00098H11.1998C11.1531 4.85431 10.4531 3.80098 9.05978 3.46098V3.00098C9.05978 2.44869 8.61206 2.00098 8.05978 2.00098C7.50749 2.00098 7.05978 2.44869 7.05978 3.00098V3.44098C5.76645 3.72098 4.72645 4.56098 4.72645 5.84764C4.72645 7.38764 5.99978 8.15431 7.85978 8.60098C9.52645 9.00098 9.85978 9.58764 9.85978 10.2076C9.85978 10.6676 9.53311 11.401 8.05978 11.401C6.68645 11.401 6.14645 10.7876 6.07311 10.001H4.60645C4.68645 11.461 5.77978 12.281 7.05978 12.5543V13.001C7.05978 13.5533 7.50749 14.001 8.05978 14.001C8.61206 14.001 9.05978 13.5533 9.05978 13.001V12.5676C10.3598 12.321 11.3931 11.5676 11.3931 10.201C11.3931 8.30764 9.77311 7.66098 8.25978 7.26764Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollarIcon.7037579d29a1012a923fa0f99d61dc71.svg";
export { ForwardRef as ReactComponent };